import { Box } from "@mantine/core";

import Flex from "components/Flex";

import { stepStyles } from "./styles";

type ProgressProps = {
  steps?: number;
  currentStep: number;
};

export const ProgressSteps = ({ steps = 7, currentStep }: ProgressProps) => {
  return (
    <Flex direction="row" gap={4}>
      {Array.from(Array(steps).keys()).map((_, stepIndex) => (
        <Box key={String(stepIndex)} sx={(theme) => stepStyles({ theme, currentStep, stepIndex })} />
      ))}
    </Flex>
  );
};
